import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3367ccd0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3367ccd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3367ccd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\iotcarduserui\\iotcardpc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3367ccd0')) {
      api.createRecord('3367ccd0', component.options)
    } else {
      api.reload('3367ccd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3367ccd0&scoped=true", function () {
      api.rerender('3367ccd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menulist/index.vue"
export default component.exports